import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  fontFamily: "字体",
  fontSize: "字体大小",
  fontWeight: "字重",
  fontStyle: "字体样式",
  lineHeight: "行高",
  bgColor: "背景颜色",
  color: "字体颜色",
  showDayTemp: "显示温度",
  // showNightTemp: "显示夜晚温度",
  showCity: "显示城市",
  showIcon: "显示图标",
  showWeatherText: "显示天气描述",
  iconSize: "天气图标大小",
  iconStyle: "图标风格",
  spacing: "文本间距",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
